module.exports = __webpack_public_path__ + "media/images/thank-you-bg-5b70ffc91f044ddc19938dcc0f816367.png";